import React, { ChangeEvent } from 'react';



export const TextField = ({ name, label, value, onChange, required, disabled }) => (
  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={name}>
      {label}  
    </label>
    <input
      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
      id={name}
      style={
        disabled == true ? { backgroundColor: '#e9ecef' } : {}
      }
      type="text"
      defaultValue={value}
      disabled={disabled == true ? true : false}
      onChange={onChange}
      required={required ? true : false}
    />
  </div>
);

export const CheckboxField = ({ name, label, value, onChange }) => (
  <div className="mb-4 flex items-center">
    <input
      className="mr-2 leading-tight"
      type="checkbox"
      id={name}
      checked={!!value}
      onChange={onChange}
    />
    <label className="text-sm" htmlFor={name}>
      {label}
    </label>
  </div>
);

export const SelectField = ({
  name,
  label,
  value,
  onChange,
  options,
}) => (
  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={name}>
      {label}
    </label>
    <select
      className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
      id={name}
      value={value}
      onChange={onChange}
    >
      {options.map((option, i) => (
        <option key={i}>{option}</option>
      ))}
    </select>
  </div>
);

export const RadioField = ({
  name,
  label,
  value,
  onChange,
  options,
}) => (
  <div className="mb-4">
    <span className="block text-gray-700 text-sm font-bold mb-2">{label}</span>
    {options.map((option, i) => (
      <label key={i} className="block text-sm mb-1">
        <input
          type="radio"
          name={name}
          value={option}
          checked={value === option}
          onChange={onChange}
        />
        {option}
      </label>
    ))}
  </div>
);

export const NumberField = ({ name, label, value, onChange }) => (
  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={name}>
    {label}
  </label><input
      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
      id={name}
      type="number"
      value={value}
      onChange={onChange} />
  </div>
);

export const FloatField = ({ name, label, value, onChange }) => (
  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={name}>
      {label}
    </label><input
      //className="shadow appearaasnce-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
      id={name}
      step="0.01"
      defaultValue="0.01"
      type="text"
      value={value}
      onChange={onChange} />
  </div>
);
